import { Step } from '../../../app/entities/step';

const progressReducer = (acc: number, step: Step | undefined) => (step?.done ? acc + 1 : acc);

export const getStageProgress = (steps: Array<Step | undefined>) => {
  const sum = steps.length;
  const done = steps.reduce(progressReducer, 0);
  return { sum, done };
};
